import React, { ReactElement } from "react";
import styles from "./contactTop.module.scss";

export default function ContactTop(): ReactElement {
    return (
        <div className="flex justify-between flex-col md:flex-row items-center h-96 md:h-72 relative  z-10">
            <div>
                <h1 className="text-3xl font-extrabold">Contact Us</h1>
                <p className="text-xl w-11/12">
                    We are open to discuss potential opportunities.
                </p>
            </div>
            <img
                src="/assets/contactOpt.png"
                alt=""
                className={` ${styles.img}`}
            />
        </div>
    );
}
